import React from 'react';
import { Box, Grid, Alert } from '@mui/material';

import { walletFormFields } from '../components/walletFormFields';
import { WalletFormValues } from '../types';

type EditFormContentProps = {
  values: Partial<WalletFormValues>;
};

export const EditFormContent: React.FC<EditFormContentProps> = ({ values }) => {
  return (
    <Grid container spacing={3}>
      <walletFormFields.Name />

      {/* Wallet Name field should be the only component in the first row. This Box takes up all remaining space. */}
      <Box width='100%' />

      <walletFormFields.WalletConfiguration disabled />

      <Grid item md={12}>
        <Alert
          severity='info'
          sx={{
            '& .MuiAlert-icon': {
              marginTop: 'auto',
              marginBottom: 'auto',
            },
          }}
        >
          Base Wallet configuration cannot be changed. To set a different configuration please
          create a new Wallet.
        </Alert>
      </Grid>

      <walletFormFields.SurveyQuestion />
      <walletFormFields.Range />
      <walletFormFields.IncentivizeResponses values={values} />
    </Grid>
  );
};
